<template lang="pug">
  .swatch.xs-6.sm-4.md-3.lg-20pct.flex-box.column.center-minor-axis.xs-mb-125m.md-mb-200m.xs-f-xsmall.max-at-tweak
    a.xs-10(:href="getObjProperty(product, 'uri')" :aria-label="`${getObjProperty(product, 'name')} product page`")
      .a-box-xs-1x1.full-width
        .a-box-content
          img-box(:mediaObj="getObjProperty(product, 'imagery.toneSwatch')")

    .name.bold.upper.xs-mt-75m.xs-ml-25m.xs-mr-25m.md-ml-50m.md-mr-50m {{ getObjProperty(product, 'name').replace(/\s*-\s*/g, ' ') }}

    .desc {{ getObjProperty(product, 'desc.short') }}

    button.btn-link.link-underline.xs-f-xsmall.max-at-tweak(@click="$listeners['add-to-compare']") Compare
</template>

<script>
  export default {
    name: "Swatch",

    props: {
      product: {
        type: Object
      }
    },

    inject: ['getObjProperty']
  };
</script>

<style scoped lang="stylus">
  .swatch
    .a-box-xs-1x1
      border-radius 100%
      overflow hidden
      width 99%

    .name
      white-space break-spaces

    .btn-link
      text-decoration underline
</style>